import React, { useState, useEffect } from 'react';
import '../App.css';
import { Tabs} from "antd";
import DOMPurify from 'dompurify';

const { TabPane } = Tabs;

const Help: React.FC = () => {
    const [activeKey, setActiveKey] = useState("1");
    const [startcontent, setStartContent] = useState("");
    const [newfilingcontent, setNewFilingContent] = useState("");
    const [nrracontent, setNRRAContent] = useState("");
    const [mistakecontent, setMistakeContent] = useState("");
    const [searchcontent, setSearchContent] = useState("");
    const [reportscontent, setReportsContent] = useState("");
    const [amendingcontent, setAmendingContent] = useState("");
    const [dtrcontent, setDTRContent] = useState("");

    useEffect(() => {
        const fetchgettingStartedHtml = async () => {
            try {
              const response = await fetch('/html/gettingStarted.html'); 
              if (response.ok) {
                const htmlContent = await response.text();
                setStartContent(DOMPurify.sanitize(htmlContent));
              } else {
                console.error('Failed to load aboutus.html');
              }
            } catch (error) {
              console.error('Error fetching aboutus.html:', error);
            }
        };

        const fetchNewFilingHtml = async () => {
            try {
              const response = await fetch('/html/newFiling.html'); 
              if (response.ok) {
                const htmlContent = await response.text();
                setNewFilingContent(DOMPurify.sanitize(htmlContent));
              } else {
                console.error('Failed to load aboutus.html');
              }
            } catch (error) {
              console.error('Error fetching aboutus.html:', error);
            }
        };

        const fetcMistakeHtml = async () => {
            try {
              const response = await fetch('/html/fixingErrors.html'); 
              if (response.ok) {
                const htmlContent = await response.text();
                setMistakeContent(DOMPurify.sanitize(htmlContent));
              } else {
                console.error('Failed to load aboutus.html');
              }
            } catch (error) {
              console.error('Error fetching aboutus.html:', error);
            }
        };

        const fetchNRRAHtml = async () => {
            try {
              const response = await fetch('/html/nrra.html'); 
              if (response.ok) {
                const htmlContent = await response.text();
                setNRRAContent(DOMPurify.sanitize(htmlContent));
              } else {
                console.error('Failed to load aboutus.html');
              }
            } catch (error) {
              console.error('Error fetching aboutus.html:', error);
            }
        };

        const fetchSearchHtml = async () => {
            try {
              const response = await fetch('/html/searchhelp.html'); 
              if (response.ok) {
                const htmlContent = await response.text();
                setSearchContent(DOMPurify.sanitize(htmlContent));
              } else {
                console.error('Failed to load aboutus.html');
              }
            } catch (error) {
              console.error('Error fetching aboutus.html:', error);
            }
        };
        const fetchReportHtml = async () => {
            try {
              const response = await fetch('/html/report.html'); 
              if (response.ok) {
                const htmlContent = await response.text();
                setReportsContent(DOMPurify.sanitize(htmlContent));
              } else {
                console.error('Failed to load aboutus.html');
              }
            } catch (error) {
              console.error('Error fetching aboutus.html:', error);
            }
        };
        const fetchAmendingHtml = async () => {
            try {
              const response = await fetch('/html/amending.html'); 
              if (response.ok) {
                const htmlContent = await response.text();
                setAmendingContent(DOMPurify.sanitize(htmlContent));
              } else {
                console.error('Failed to load aboutus.html');
              }
            } catch (error) {
              console.error('Error fetching aboutus.html:', error);
            }
        };
        const fetchDTRHtml = async () => {
            try {
              const response = await fetch('/html/dtr.html'); 
              if (response.ok) {
                const htmlContent = await response.text();
                setDTRContent(DOMPurify.sanitize(htmlContent));
              } else {
                console.error('Failed to load aboutus.html');
              }
            } catch (error) {
              console.error('Error fetching aboutus.html:', error);
            }
        };
        
        fetchgettingStartedHtml()
        fetchNewFilingHtml()
        fetchNRRAHtml()
        fetcMistakeHtml()
        fetchSearchHtml()
        fetchReportHtml()
        fetchAmendingHtml()
        fetchDTRHtml()
    },[]);

    const handleTabChange = (key: any) => {
        setActiveKey(key);
    };

  return (
    <div className='text-style  tab-container'>
      <div>
        <Tabs
          defaultActiveKey="1"
          activeKey={activeKey}
          onChange={handleTabChange}
          type="card"
          tabBarStyle={{
            height: '30px',
            marginBottom: '3px',
          }}
          className='ml-2'>
            <TabPane tab="Getting started" key="1">
                <div className='ml-2' dangerouslySetInnerHTML={{ __html: startcontent }} />
            </TabPane>
            <TabPane tab="Entering new filings" key="2">
                <div className='ml-2' dangerouslySetInnerHTML={{ __html: newfilingcontent }} />
            </TabPane>
            <TabPane tab="NRRA Information" key="3">
                <div className='ml-2' dangerouslySetInnerHTML={{ __html: nrracontent }} />
            </TabPane>
            <TabPane tab="Fixing mistakes" key="4">
                <div className='ml-2' dangerouslySetInnerHTML={{ __html: mistakecontent }} />
            </TabPane>
            <TabPane tab="Searching for filings" key="5">
                <div className='ml-2' dangerouslySetInnerHTML={{ __html: searchcontent }} />
            </TabPane>
            <TabPane tab="Running tax reports" key="6">
                <div className='ml-2' dangerouslySetInnerHTML={{ __html: reportscontent }} />
            </TabPane>
            <TabPane tab="Amending semi-annual reports" key="7">
                <div className='ml-2' dangerouslySetInnerHTML={{ __html: amendingcontent }} />
            </TabPane>
            <TabPane tab="Delinquent Tax Reports" key="8">
                <div className='ml-2' dangerouslySetInnerHTML={{ __html: dtrcontent }} />
            </TabPane>
          </Tabs>
      </div>
    </div>
  );
}

export default Help;
